module.exports = __webpack_public_path__ + "static/media/SM-ST1-TRIAL.38b9b3c8.mp3";